import GlobalStore from 'shared/globalStore/assets/scripts/globalStore'

import PmcBridge from 'shared/services/pmc-bridge'

export default class HeaderTopbar {
	private headerTopbar: HTMLElement | null
	private magazineCoverConfig: string | undefined
	private magazineCardLink: HTMLAnchorElement | null | undefined
	private subscribeCta: HTMLAnchorElement | null | undefined
	private PMCBrige: PmcBridge
	private isUserSubscribed: Awaited<ReturnType<typeof PmcBridge.prototype.hasSubscription>>
	private store: GlobalStore

	constructor() {
		this.store = new GlobalStore()
		this.magazineCoverConfig = this.store.brand?.magazine.cover
		this.headerTopbar = document.querySelector('.headerTopbar')
		this.magazineCardLink = this.headerTopbar?.querySelector('.headerTopbar-cardLink')
		this.subscribeCta = this.headerTopbar?.querySelector(
			'.headerTopbar-linksPrimarySubscribeCta'
		)
		this.PMCBrige = new PmcBridge()
		this.isUserSubscribed = false

		this.updateMagazineCard = this.updateMagazineCard.bind(this)
		this.removeSubscribeCta = this.removeSubscribeCta.bind(this)
	}

	async init() {
		if (this.magazineCoverConfig) {
			this.injectCoverImage(this.magazineCoverConfig)
		}

		this.isUserSubscribed = await this.PMCBrige.hasSubscription()
		if (this.isUserSubscribed) {
			this.updateMagazineCard()
			this.removeSubscribeCta()
		}
	}

	private injectCoverImage(imageUrl: string) {
		const container = this.headerTopbar?.querySelector('.headerTopbar-cardLinkImage')
		if (!container) return

		const cdnParams =
			'operation=fit&width=54&height=70&quality=100&crop-from=center&format=avif'
		const cdnParams2x =
			'operation=fit&width=108&height=140&quality=100&crop-from=center&format=avif'
		const separator = imageUrl.includes('?') ? '&' : '?'

		const img = document.createElement('img')
		img.sizes = '54px'
		img.src = `${imageUrl}${separator}${cdnParams}`
		img.srcset = `${imageUrl}${separator}${cdnParams} 54w, ${imageUrl}${separator}${cdnParams2x} 108w`
		img.className = 'apply-ratio headerTopbar-coverImage'
		img.alt = ''
		img.loading = 'lazy'

		container.appendChild(img)
	}

	/**
	 * Update the magazine card link href to the subscribed href
	 */
	updateMagazineCard() {
		const subscribedHref = this.magazineCardLink?.getAttribute('data-subscribed-href')

		if (subscribedHref && this.magazineCardLink) {
			this.magazineCardLink.setAttribute('href', subscribedHref)
		}
	}

	/**
	 * Remove the subscribe CTA if the user has subscribed
	 */
	removeSubscribeCta() {
		this.subscribeCta?.remove()
	}
}
